/**
 * One status → badge map for leagues, tournaments, drop-ins, matches and
 * registrations (PR 7b). Every list and detail page shows the same colour for
 * the same status.
 *
 *   in_progress, active, paused           In Progress (Live for a match)  success, pulsing dot
 *   registration_open, open               Registration Open / Open         sport
 *   scheduled                             Scheduled                        neutral
 *   registration_closed, draft, postponed as named                         warning
 *   completed                             Completed                        muted
 *   cancelled                             Cancelled                        danger
 *   expired (match left open, no result)  Expired, no result               muted
 */
import { LEAGUE_STATUS_LABELS } from '../league/leagueStatus';

const BADGES = Object.freeze({
  in_progress: { label: LEAGUE_STATUS_LABELS.in_progress, tone: 'success', pulse: true },
  active: { label: LEAGUE_STATUS_LABELS.in_progress, tone: 'success', pulse: true },
  paused: { label: 'Paused', tone: 'success', pulse: true },
  registration_open: { label: LEAGUE_STATUS_LABELS.registration_open, tone: 'sport' },
  open: { label: 'Open', tone: 'sport' },
  scheduled: { label: 'Scheduled', tone: 'neutral' },
  registration_closed: { label: LEAGUE_STATUS_LABELS.registration_closed, tone: 'warning' },
  draft: { label: LEAGUE_STATUS_LABELS.draft, tone: 'warning' },
  postponed: { label: 'Postponed', tone: 'warning' },
  completed: { label: LEAGUE_STATUS_LABELS.completed, tone: 'muted' },
  cancelled: { label: LEAGUE_STATUS_LABELS.cancelled, tone: 'danger' },
  expired: { label: 'Expired, no result', tone: 'muted' },
  // Registrations (tournament entries, join requests)
  approved: { label: 'Approved', tone: 'success' },
  pending: { label: 'Pending', tone: 'warning' },
  waitlisted: { label: 'Waitlisted', tone: 'warning' },
  rejected: { label: 'Rejected', tone: 'danger' },
  withdrawn: { label: 'Withdrawn', tone: 'muted' },
});

const LIVE = new Set(['in_progress', 'active']);

/**
 * The badge of a status: { label, tone, pulse }. A live match reads "Live";
 * an unknown status is neutral with its own text.
 * @param {string} status
 * @param {{ kind?: 'match' }} [opts]
 */
export const statusBadge = (status, { kind } = {}) => {
  const key = String(status || '').toLowerCase();
  const badge = BADGES[key];
  if (!badge) {
    return { label: String(status || 'Unknown').replace(/_/g, ' '), tone: 'neutral', pulse: false };
  }
  return {
    label: kind === 'match' && LIVE.has(key) ? 'Live' : badge.label,
    tone: badge.tone,
    pulse: Boolean(badge.pulse),
  };
};

export const STATUS_TONES = BADGES;
